:host {
    /**
    * @prop --tabs-buttons-wrapper-min-width: Set the scroll area width. Default to 250px and should not go over ~300px. As direct children is a full scrollable area, it has an automatic width set by parent.
    * @prop --tabs-buttons-list-width: Set the min-width of the tabs-buttons list. Play with this value and media queries to render an horizontal scroll area for mobile. 
    */
    --tabs-buttons-list-width: auto;
    --tabs-buttons-wrapper-min-width: 250px;

    display: grid;
}

.joy-tabs {
    display: block;

    &-buttons__wrapper {
        overflow-x: auto;
        width: 100%;
        min-width: var(--tabs-buttons-wrapper-min-width);

    }

    &-buttons {
        display: flex;
        justify-content: flex-start;
        align-items: flex-end;
        min-width: var(--tabs-buttons-list-width);
    }


}